// src/Theme.js

export const Theme = {
  /* ---------------------------------------------
     Typography
  --------------------------------------------- */
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",

  /* ---------------------------------------------
     Color System — Wholistic Health
  --------------------------------------------- */
  colors: {
    primary: "#0067B3",
    background: "#F6F8FC",
    card: "#FFFFFF",
    text: "#1F2937",
    muted: "#6B7280",
    border: "#E5E7EB",
    highlight: "#EEF4FF",

    /* Semantic helpers */
    success: "#3B7D23",
    warning: "#FFCC00",
    danger: "#B00000",
  },

  /* ---------------------------------------------
     Shape & Spacing
  --------------------------------------------- */
  radius: "12px",
  radiusLg: "18px",
  radiusFull: "999px",

  spacing: {
    xs: "0.25rem",
    sm: "0.5rem",
    md: "1rem",
    lg: "1.5rem",
    xl: "2rem",
  },

  /* 🔹 STANDARD PAGE CONTAINER */
  layout: {
    page: {
      maxWidth: 800,
      margin: "0 auto",
      padding: "0 16px",
      width: "100%",
    },
  },

  /* ---------------------------------------------
     Shadows — Soft, Calm Elevation
  --------------------------------------------- */
  shadow: {
    sm: "0 2px 6px rgba(0,0,0,0.04)",
    md: "0 8px 24px rgba(0,0,0,0.06)",
    lg: "0 12px 32px rgba(0,0,0,0.08)",
  },

  /* ---------------------------------------------
     Motion
  --------------------------------------------- */
  transition: {
    fast: "150ms ease",
    normal: "250ms ease",
  },
};
